import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { NativeSelect, FormLabel, Grid } from "@mui/material";
import { MdKeyboardArrowDown } from "react-icons/md";
import { PALETTE } from "../../Theme/Palette";

//todo: qsmt error byd handle beshe
export function SelectBox({
  label,
  value,
  id,
  name,
  data = [],
  labelKey = "name",
  idKey = "id",
  disabled = false,
  containerGridSize = { xs: 12, sm: 6 },
  labelGridSize = { xs: 5 },
  inputGridSize = { xs: 7 },
  haveEmptyOption = true,
  onChange = () => {},
  error = false,
}) {
  const [showSubmitError, setShowSubmitError] = useState(
    (!value || value === undefined || value === "") && error
  );

  useEffect(() => {
    setShowSubmitError((!value || value === undefined || value === "") && error);
  }, [error, value]);
  return (
    <Grid
      container
      item
      {...containerGridSize}
      direction="row-reverse"
      alignItems="center"
      sx={{
        boxSizing: "border-box",
        paddingLeft: { xs: 0, sm: "0.5rem", md: "1rem" },
        marginBottom: "0.7rem",
      }}
    >
      {label && (
        <Grid item {...labelGridSize}>
          <FormLabel
            htmlFor={id}
            sx={{
              textAlign: "right",
              color: "#4C466F !important",
              fontSize: 14,
            }}
          >
            {label}
          </FormLabel>
        </Grid>
      )}
      <Grid item {...inputGridSize}>
        <NativeSelect
          onChange={onChange}
          value={value ?? ""}
          IconComponent={MdKeyboardArrowDown}
          disableUnderline
          disabled={disabled}
          id={id}
          name={name}
          sx={{
            width: "100%",
            color: PALETTE.third + " !important",
            fontWeight: "bold",
            marginTop: "0px !important",
            bgcolor: !disabled ? PALETTE.primary : PALETTE.fifth,
            textAlign: "right",
            borderRadius: "0.5rem",
            overflow: "hidden",
            direction: "rtl",
            fontSize: 14,
            border: `1px solid ${
              disabled ? "transparent" : showSubmitError ? PALETTE.ninth : PALETTE.fourth
            }`,
            "& select": {
              padding: "10px 0.7rem !important",
              height: "20px",
              border: "0 !important",
            },
            "& svg": {
              fontSize: "1.4rem",
              display: disabled && "none",
              right: "100% !important",
              left: "0px !important",
              top: "50% !important",
              transform: "translate(115%,-50%) !important",
            },
            "& :disabled , & .Mui-disabled": {
              WebkitTextFillColor: PALETTE.sixth,
              color: PALETTE.sixth,
              backgroundColor: PALETTE.fifth,
              border: "1px solid transparent !important",
            },
          }}
        >
          {haveEmptyOption && <option value=""></option>}
          {data.map((item) => (
            <option
              value={item[idKey]}
              key={item[idKey]}
              style={{ color: PALETTE.third, fontWeight: "bold" }}
            >
              {item[labelKey]}
            </option>
          ))}
        </NativeSelect>
      </Grid>
    </Grid>
  );
}

SelectBox.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  name: PropTypes.string,
  data: PropTypes.array,
  labelKey: PropTypes.string,
  idKey: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};
